import { MARKER_URL_BY_VERSION } from '../constants';

export const MARKER_URL = MARKER_URL_BY_VERSION('v2');
